import React, { useEffect } from "react";
import { FaRegCheckCircle } from "react-icons/fa";
import { Container } from "./styles";

export default function Feedback({ show, setShow, timeout = 2000 }) {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false);
      }, timeout);
    }
  }, [show]);

  return show ? (
    <Container>
      <FaRegCheckCircle />
      <span>Salvo!</span>
    </Container>
  ) : null;
}
